import { Check, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Shared";
import { SERVICES, LINKS } from "@/lib/site";

function ServiceCard({ data, flagship }) {
  return (
    <div
      data-testid={`service-card-${flagship ? "business" : "career"}`}
      className={`group relative flex flex-col rounded-2xl border border-[#0B1F3A]/8 bg-white p-8 md:p-10 shadow-[0_8px_30px_rgba(11,31,58,0.04)] transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_rgba(11,31,58,0.10)] ${
        flagship ? "lg:col-span-3" : "lg:col-span-2"
      }`}
    >
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center rounded-full border border-[#C8A75D]/40 bg-[#C8A75D]/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-[#8a6d29]">
          {data.tag}
        </span>
        <span className="font-display text-sm font-bold text-[#0B1F3A]/20 group-hover:text-[#C8A75D] transition-colors duration-300">
          {flagship ? "01" : "02"}
        </span>
      </div>

      <h3 className="font-display mt-6 text-2xl md:text-3xl font-bold tracking-tight text-[#0B1F3A]">
        {data.title}
      </h3>
      <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-[#4B5563]">
        {data.description}
      </p>

      <div
        className={`mt-8 grid gap-x-8 gap-y-3.5 ${
          flagship ? "sm:grid-cols-2 lg:grid-cols-3" : "sm:grid-cols-2"
        }`}
      >
        {data.items.map((item) => (
          <div key={item} className="flex items-start gap-3">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#0B1F3A]">
              <Check className="h-3 w-3 text-[#C8A75D]" strokeWidth={3} />
            </span>
            <span className="text-sm font-medium text-[#1F2937]">{item}</span>
          </div>
        ))}
      </div>

      <div className="mt-auto pt-9">
        <a
          href={LINKS.instagramDM}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`service-cta-${flagship ? "business" : "career"}`}
          className="group/link inline-flex items-center gap-2 text-sm font-semibold text-[#0B1F3A] transition-colors duration-300 hover:text-[#C8A75D]"
        >
          Book a Consultation
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
        </a>
      </div>
    </div>
  );
}

export default function Services() {
  return (
    <section id="services" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Our Expertise</Eyebrow>
          <div className="mt-6 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-display max-w-2xl text-4xl md:text-5xl font-bold tracking-tight leading-[1.1] text-[#0B1F3A]">
              Guidance that spans careers and companies.
            </h2>
            <p className="max-w-md text-base leading-relaxed text-[#4B5563]">
              Two focused practices, one standard of care — practical, personalised
              consultancy built around where you want to go.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-6 lg:grid-cols-5">
          <Reveal className="lg:col-span-3" delay={0.05}>
            <ServiceCard data={SERVICES.flagship} flagship />
          </Reveal>
          <Reveal className="lg:col-span-2" delay={0.12}>
            <ServiceCard data={SERVICES.career} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
